export const parseBulkCsv = (text, headers, optionalHeaders = []) => {
  const records = []; let row = [], value = '', quoted = false, closed = false;
  let input = text.replace(/^\uFEFF/, '');
  const directive = input.match(/^sep=([,;\t])\r?\n/i);
  let delimiter = directive?.[1];
  if (directive) input = input.slice(directive[0].length);
  if (!delimiter) {
    const counts = { ',': 0, ';': 0, '\t': 0 };
    let inQuotes = false;
    for (let i = 0; i < input.length; i++) {
      const char = input[i];
      if (char === '"') {
        if (inQuotes && input[i + 1] === '"') i++;
        else inQuotes = !inQuotes;
      } else if (!inQuotes) {
        if (char === '\r' || char === '\n') break;
        if (char in counts) counts[char]++;
      }
    }
    delimiter = Object.keys(counts).sort((a, b) => counts[b] - counts[a])[0];
  }
  for (let i = 0; i <= input.length; i++) {
    const c = input[i];
    if (quoted) {
      if (c === '"' && input[i + 1] === '"') { value += '"'; i++; }
      else if (c === '"') { quoted = false; closed = true; }
      else if (c === undefined) throw new Error('Unclosed CSV quote.');
      else value += c;
    } else if (c === delimiter || c === '\n' || c === '\r' || c === undefined) {
      row.push(value.trim()); value = ''; closed = false;
      if (c !== delimiter) { if (row.some(Boolean)) records.push(row); row = []; if (c === '\r' && input[i + 1] === '\n') i++; }
    } else if (c === '"' && !value && !closed) quoted = true;
    else { if (closed || c === '"') throw new Error('Invalid CSV quoting.'); value += c; }
  }
  const names = (records.shift() || []).map(name => name.toLowerCase().replace(/[\s-]+/g, '_'));
  if (new Set(names).size !== names.length) throw new Error('Duplicate CSV headers.');
  const missing = headers.filter(h => !names.includes(h));
  const unexpected = names.filter(h => !headers.includes(h) && !optionalHeaders.includes(h));
  if (missing.length || unexpected.length) {
    throw new Error([
      missing.length ? `Missing columns: ${missing.join(', ')}.` : '',
      unexpected.length ? `Unexpected columns: ${unexpected.map(h => h || '(blank)').join(', ')}.` : '',
      'Use Download CSV Template, fill in the item rows, and upload that file. Item Reference is for looking up IDs.'
    ].filter(Boolean).join(' '));
  }
  if (!records.length) throw new Error('CSV has no item rows.');
  if (records.length > 1000) throw new Error('Import up to 1,000 rows at a time.');
  return records.map((values, i) => {
    if (values.length !== names.length) throw new Error(`Row ${i + 2}: incorrect column count.`);
    return Object.fromEntries(names.map((name, j) => [name, values[j]]));
  });
};
export const csvNumber = (value, label, allowZero = false) => {
  const number = Number(value);
  if (!String(value).trim() || !Number.isFinite(number) || (allowZero ? number < 0 : number <= 0)) throw new Error(`${label} must be ${allowZero ? 'zero or positive' : 'positive'}.`);
  return number;
};
export const downloadCsv = (name, headers, rows = []) => {
  const escape = value => `"${String(value ?? '').replace(/^[=+@-]/, "'$&").replace(/"/g, '""')}"`;
  const content = [headers, ...rows.map(row => headers.map(h => row[h]))].map(row => row.map(escape).join(',')).join('\r\n');
  const url = URL.createObjectURL(new Blob(['\uFEFF', content], { type: 'text/csv;charset=utf-8;' }));
  const a = document.createElement('a'); a.href = url; a.download = name; a.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
};
